module.exports = __webpack_public_path__ + "roboto-lightitalic-webfont.16f2b6089f568a7c1a8d.ttf";


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/Exchange-NewsAdmin-Frontend/src/assets/fonts/roboto-lightitalic-webfont.ttf
// module id = ../../../../../src/assets/fonts/roboto-lightitalic-webfont.ttf
// module chunks = styles